function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 124,
  fill: "#edebdc",
  r: 90
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m190 178v84h-32c0-6.627 5.373-12 12-12h8v-16h-.814c-12.805 0-23.186-10.381-23.186-23.186v-26.814z",
  fill: "#c1dbdc"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m190 266h-32c-2.211 0-4-1.791-4-4 0-8.822 7.176-16 16-16h4v-8.186c-13.496-1.582-24-13.088-24-27v-26.814c0-1.955 1.414-3.625 3.344-3.945l36-6c1.168-.197 2.348.135 3.242.893.898.76 1.414 1.877 1.414 3.053v84c0 2.208-1.789 3.999-4 3.999zm-26.926-8h22.926v-75.277l-28 4.666v23.426c0 10.578 8.609 19.186 19.188 19.186h.812c2.211 0 4 1.791 4 4v16c0 2.209-1.789 4-4 4h-8c-2.957-.001-5.543 1.61-6.926 3.999z",
  fill: "#4c241d"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m63.733 72 45.182 91.123c11.043 22.272 34.421 35.521 59.029 33.453l57.636-4.843c25.107-2.11 44.419-23.274 44.419-48.68v-63.053l-31.733 64s-39.667-40-107.1-12l-55.96-77.591c-4.391-6.088-12.41-8.327-19.32-5.395l-20.433 8.672c-3.306 1.403-5.453 4.647-5.453 8.239 0 5.361 4.681 9.52 10.005 8.889z",
  fill: "#9dc1e4"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m162.816 200.791c-24.301.002-46.465-13.664-57.484-35.891l-43.93-88.596-20.926 2.482c-3.682.432-7.365-.725-10.127-3.18-2.763-2.456-4.349-5.983-4.349-9.68 0-5.209 3.098-9.891 7.891-11.922l20.434-8.672c8.684-3.689 18.609-.914 24.127 6.736l54.127 75.051c34.602-13.533 61.836-9.387 78.762-3.389 12.262 4.344 20.918 10.174 25.633 13.877l29.445-59.385c.82-1.662 2.672-2.551 4.496-2.117 1.808.424 3.085 2.038 3.085 3.895v63.053c0 27.268-21.121 50.4-48.082 52.666l-57.637 4.844c-1.832.154-3.656.228-5.465.228zm-99.082-132.791c1.506 0 2.9.85 3.582 2.223l45.184 91.123c10.375 20.926 32.039 33.189 55.109 31.244l57.637-4.844c22.852-1.92 40.754-21.551 40.754-44.693v-45.983l-24.152 48.707c-.57 1.156-1.668 1.965-2.941 2.172-1.297.205-2.57-.217-3.48-1.133-1.547-1.545-38.742-37.688-102.727-11.123-1.721.711-3.695.15-4.777-1.354l-55.96-77.591c-3.32-4.605-9.299-6.27-14.514-4.053l-20.434 8.672c-1.831.778-3.015 2.567-3.015 4.559 0 1.434.59 2.748 1.662 3.701 1.074.953 2.453 1.377 3.873 1.215l23.727-2.814c.158-.018.316-.028.472-.028z",
  fill: "#4c241d"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m212 168s28 28-8 48l8.211 4.692c3.58 2.046 5.789 5.853 5.789 9.976v31.332h-32c0-6.627 5.373-12 12-12h8v-16h-.814c-12.805 0-23.186-10.381-23.186-23.186v-26.814",
  fill: "#9dc1e4"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m218 266h-32c-2.211 0-4-1.791-4-4 0-8.822 7.176-16 16-16h4v-8.186c-13.496-1.582-24-13.088-24-27v-26.814c0-2.209 1.789-4 4-4s4 1.791 4 4v26.814c0 10.578 8.609 19.186 19.188 19.186h.812c2.211 0 4 1.791 4 4v16c0 2.209-1.789 4-4 4h-8c-2.957 0-5.543 1.611-6.926 4h22.926v-27.332c0-2.68-1.445-5.172-3.773-6.504l-8.211-4.691c-1.254-.717-2.023-2.053-2.016-3.496.008-1.445.797-2.771 2.059-3.473 9.688-5.383 15.113-11.746 16.133-18.914 1.684-11.809-8.918-22.66-9.027-22.768-1.551-1.566-1.547-4.098.016-5.654 1.566-1.557 4.09-1.553 5.648.004.551.553 13.504 13.709 11.293 29.488-1.133 8.088-5.949 15.189-14.348 21.176l2.422 1.383c4.816 2.754 7.805 7.906 7.805 13.449v31.332c-.001 2.209-1.79 4-4.001 4z",
  fill: "#4c241d"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m152 164-13.267 17.689c-6.215 8.287-15.468 8.943-24.733 4.311 0 0-14 10-2 34l-10-22s0 8-6 18l2-26c0-8.837 9.163-18 18-18h6.935l3.412-9.032c3.402-9.008 12.025-14.968 21.653-14.968",
  fill: "#9dc1e4"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  fill: "#4c241d"
}, /*#__PURE__*/React.createElement("path", {
  d: "m112.002 224c-1.469 0-2.879-.811-3.58-2.211-.736-1.475-1.385-2.902-1.951-4.287l-3.25-7.152c-.924 2.375-2.154 4.98-3.791 7.709-.955 1.59-2.885 2.322-4.645 1.752-1.768-.562-2.916-2.268-2.773-4.117l2-26c-.012-10.798 10.884-21.694 21.988-21.694h4.168l2.436-6.445c3.966-10.5 14.171-17.555 25.396-17.555 2.211 0 4 1.791 4 4s-1.789 4-4 4c-7.918 0-15.115 4.977-17.912 12.383l-3.412 9.031c-.588 1.557-2.078 2.586-3.742 2.586h-6.934c-6.674 0-14 7.326-14 14l-.309 4.023c.871-.076 1.676.137 2.379.559 2.168-7.824 7.225-11.566 7.605-11.838 1.203-.859 2.785-.988 4.113-.322 5.771 2.889 13.877 4.684 19.746-3.133l13.266-17.689c1.324-1.764 3.836-2.125 5.598-.799 1.77 1.324 2.129 3.832.801 5.6l-13.266 17.689c-6.428 8.568-16.416 10.965-27.104 6.67-2.422 2.939-6.383 10.33-.977 23.652l1.787 3.934c.902 1.984.049 4.326-1.918 5.264-.555.265-1.141.39-1.719.39z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 60,
  r: 2.667
}));

function SvgDino04(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dino15",
    enableBackground: "new 0 0 300 300",
    height: 512,
    viewBox: "0 0 300 300",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDino04);
export default __webpack_public_path__ + "static/media/dino-04.8096d7e0.svg";
export { ForwardRef as ReactComponent };